import { isValid } from 'iban';
import { generateFinlandBic } from './bic-mapping';
import { validationCodes, markets } from '../../constants';
import { getErrorByCode } from '../validation.helper';
import { IAppState, IFormControl } from '../../types';

export function validateIban(ctrl: IFormControl, appState: IAppState) {
    const control = ctrl;
    if (!control.isValid) {
        return;
    }

    control.isValid = isValid(control.value);

    if (control.isValid && appState.formMeta.market === markets.estonia) {
        const eeRegex = new RegExp("^([eE]{2})(.+)$");
        control.isValid = control.value.match(eeRegex) !== null ? true : false;
    }

    const letterNumberRegex = new RegExp("^[a-zA-Z0-9]*$");
    if (control.value.match(letterNumberRegex) === null) {
        control.isValid = false;
    }

    if (!control.isValid) {
        control.validationMessage = getErrorByCode(
            control.validations || [],
            validationCodes.invalid,
            validationCodes.invalid,
        );
        return;
    }

    if (appState.formMeta.market === markets.finland) {
        const bicControl = appState.controlsState.bic;
        const bic = generateFinlandBic(control.value);

        if (bic && bicControl) {
            bicControl.value = bic;
        }
    }
}
